import { render } from "./UserModal.vue?vue&type=template&id=0762b658&scoped=true"
import script from "./UserModal.vue?vue&type=script&lang=js"
export * from "./UserModal.vue?vue&type=script&lang=js"

import "./UserModal.vue?vue&type=style&index=0&id=0762b658&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0762b658"

export default script